import { IconType } from "react-icons/lib";
import { PiDotsNine, PiDotsSix, PiDotsThree } from "react-icons/pi";

import {
  useGetAgenciesGeographiesAgenciesGet,
  useGetRegionsGeographiesRegionsGet,
  useGetZonesGeographiesZonesGet,
} from "@/services/2/react-query/hooks";

const InnerTerritoryName = ({ Icon, name }: { Icon: IconType; name: string }) => {
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      <Icon style={{ display: "inline" }} /> {name}
    </span>
  );
};

const AgencyComponent = ({ name }: { name: string }) => (
  <InnerTerritoryName Icon={PiDotsThree} name={name} />
);
const ZoneComponent = ({ name }: { name: string }) => (
  <InnerTerritoryName Icon={PiDotsSix} name={`Zone de ${name}`} />
);
const RegionComponent = ({ name }: { name: string }) => (
  <InnerTerritoryName Icon={PiDotsNine} name={`Région ${name}`} />
);

export const AgencyName = ({ agencyUuid }: { agencyUuid: string }) => {
  const { data } = useGetAgenciesGeographiesAgenciesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const agency = data?.find(a => a.uuid === agencyUuid);
  if (agency) {
    return <AgencyComponent name={agency.name} />;
  }
  return null;
};

export const ZoneName = ({ zoneUuid }: { zoneUuid: string | null }) => {
  const { data } = useGetZonesGeographiesZonesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const zone = data?.find(z => z.uuid === zoneUuid);
  if (zone) {
    return <ZoneComponent name={zone.name} />;
  }
  return null;
};

export const RegionName = ({ regionUuid }: { regionUuid: string }) => {
  const { data } = useGetRegionsGeographiesRegionsGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const region = data?.find(r => r.uuid === regionUuid);
  if (region) {
    return <RegionComponent name={region.name} />;
  }
  return null;
};

export const TerritoryName = ({ territoryUuid }: { territoryUuid: string }) => {
  const { data: agencyData } = useGetAgenciesGeographiesAgenciesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });
  const { data: mutAreaData } = useGetZonesGeographiesZonesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });
  const { data: regionData } = useGetRegionsGeographiesRegionsGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const agency = agencyData?.find(a => a.uuid === territoryUuid);
  if (agency) {
    return <AgencyComponent name={agency.name} />;
  }
  const mutArea = mutAreaData?.find(ma => ma.uuid === territoryUuid);
  if (mutArea) {
    return <ZoneComponent name={mutArea.name} />;
  }
  const region = regionData?.find(r => r.uuid === territoryUuid);
  if (region) {
    return <RegionComponent name={region.name} />;
  }
  return null;
};

export const Territories = ({ territoryUuids }: { territoryUuids: string[] }) => {
  const territoriesJSX = territoryUuids.map(t => <TerritoryName key={t} territoryUuid={t} />);
  return territoriesJSX.flatMap((e, i) => [e, <span key={i}>, </span>]).slice(0, -1);
};
